import React, { useMemo } from "react";
import { TourEngine } from "../shared/TourEngine";
import { getCurrentReleaseManifest } from "./releaseManifest";
import { buildTourStepsFromFeatures } from "./tourStepBuilder";

/**
 * Hosts the generic TourEngine for a release walkthrough.
 */
export function TourEngineHost({
  releaseId,
  featureIds,
  allowSkip = false,
  allowHardwareBackDismiss = false,
  allowDismissOnOffTargetInteraction = false,
  estimatedDurationMinutes = 1,
  onComplete,
  onCancel,
  onGuidedModeChange,
}) {
  const steps = useMemo(() => {
    const manifest = getCurrentReleaseManifest(releaseId);
    return buildTourStepsFromFeatures(featureIds, {
      releaseMeta: manifest?.meta || { releaseId },
    });
  }, [releaseId, featureIds]);

  if (!steps.length) {
    return null;
  }

  return (
    <TourEngine
      steps={steps}
      allowSkip={allowSkip}
      allowPrevious
      allowHardwareBackDismiss={allowHardwareBackDismiss}
      allowDismissOnOffTargetInteraction={allowDismissOnOffTargetInteraction}
      estimatedDurationMinutes={estimatedDurationMinutes}
      onComplete={onComplete}
      onCancel={onCancel}
      onGuidedModeChange={onGuidedModeChange}
    />
  );
}
